<div class="div-loader" *ngIf="loader.loading">
  <div class="div-img">
    <img alt="icon-message" src="{{ image }}">
  </div>
  <div class="div-text">
    <h1>{{ loader.okMessage | translatePipe }}</h1>
  </div>
</div>
